// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OlPI","type":"styles_type__2lUM_","choices":"styles_choices__3d-CA"};